/** Grunnene ved avvis av et signal (VIB-2986). Samme nøkler som CHECK-en på signal_dismissals.reason. */
export type SignalDismissReason = "too_small" | "wrong_time" | "known" | "not_my_customer" | "other";

export const SIGNAL_DISMISS_REASONS: ReadonlyArray<{ reason: SignalDismissReason; label: string }> = [
  { reason: "too_small", label: "For lite for video" },
  { reason: "wrong_time", label: "Feil tidspunkt" },
  { reason: "known", label: "Kjenner til det" },
  { reason: "not_my_customer", label: "Ikke min kunde" },
  { reason: "other", label: "Annet" },
];

export function dismissReasonLabel(reason: unknown): string | null {
  return SIGNAL_DISMISS_REASONS.find((r) => r.reason === reason)?.label ?? null;
}
